import React, { useState, useEffect } from 'react';
import WorkItem from './WorkItem';
import WorkPopup from '../WorkPopup';
import FilterBar from './FilterBar';
import styles from './WorksGrid.module.css';

const WorksGrid = ({ works, filters }) => {
  const [selectedWork, setSelectedWork] = useState(null);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [activeFilter, setActiveFilter] = useState('all');
  const [filteredWorks, setFilteredWorks] = useState(works);

  // Фильтрация работ при изменении активного фильтра
  useEffect(() => {
    if (activeFilter === 'all') {
      setFilteredWorks(works);
    } else {
      setFilteredWorks(works.filter(work => work.type === activeFilter));
    }
  }, [activeFilter, works]);

  const handleItemClick = (work) => {
    setSelectedWork(work);
    setIsPopupOpen(true);
    document.body.style.overflow = 'hidden';
  };

  const handleClosePopup = () => {
    setIsPopupOpen(false);
    setSelectedWork(null);
    document.body.style.overflow = 'auto';
  };

  const handleFilterChange = (filterId) => {
    setActiveFilter(filterId);
    // Прокрутка к верху сетки при смене фильтра
    // const gridElement = document.querySelector(`.${styles.worksGrid}`);
    // if (gridElement) {
    //   gridElement.scrollIntoView({ behavior: 'smooth' });
    // }
  };

  return (
    <>
      {/* Фильтры */}
      <FilterBar 
        filters={filters}
        activeFilter={activeFilter}
        onFilterChange={handleFilterChange}
      />

      {/* Сетка работ */}
      <div className={styles.worksGrid}>
        {filteredWorks.map((work, index) => (
          <WorkItem
            key={work.id}
            work={work}
            index={index}
            onItemClick={handleItemClick}
          />
        ))}
      </div>

      {/* Если нет работ после фильтрации */}
      {filteredWorks.length === 0 && (
        <div className={styles.noResults}>
          <h3>Работы не найдены</h3>
          <p>Попробуйте выбрать другой фильтр</p>
        </div>
      )}

      {/* Попап */}
      {isPopupOpen && selectedWork && (
        <WorkPopup
          work={selectedWork}
          onClose={handleClosePopup}
        />
      )}
    </>
  );
};

export default WorksGrid;